__turbopack_context__.v({
  "about_bottom": "Aboutus-module-scss-module__iLIqBq__about_bottom",
  "about_img_sec": "Aboutus-module-scss-module__iLIqBq__about_img_sec",
  "about_top": "Aboutus-module-scss-module__iLIqBq__about_top",
  "aboutus": "Aboutus-module-scss-module__iLIqBq__aboutus",
  "amenities": "Aboutus-module-scss-module__iLIqBq__amenities",
  "amenities_main": "Aboutus-module-scss-module__iLIqBq__amenities_main",
  "gallery_child": "Aboutus-module-scss-module__iLIqBq__gallery_child",
  "gallery_main": "Aboutus-module-scss-module__iLIqBq__gallery_main",
  "our_gallery": "Aboutus-module-scss-module__iLIqBq__our_gallery",
});
